import { AxisId } from 'ff/debrief/models';

export function getFormatter(axisId: AxisId, speedUnit?: string) {
    switch (axisId) {
        case 'altitude':
        case 'above_ground_level':
            return altitudeFormatter;
        case 'airspeed':
        case 'ground_speed':
            return (value: number) => airspeedFormatter(value, speedUnit);
        case 'pitch':
            return angleFormatter;
        case 'bank':
            return bankFormatter;
        case 'g_load':
            return gLoadFormatter;
        case 'terrain_elevation':
            return altitudeFormatter;
        default:
            throw new Error('no value formatter found for selected axis');
    }
}

export function altitudeFormatter(value: number): string {
    const roundedValue = Math.round(value);
    return roundedValue.toString().concat(' ft');
}

export function airspeedFormatter(value: number, unit?: string): string {
    const roundedValue = Math.round(value);
    const displayUnit = unit || 'kts';
    return roundedValue.toString().concat(' ', displayUnit);
}

export function angleFormatter(value: number): string {
    const roundedValue = Math.round(value);
    return roundedValue.toString().concat(' deg');
}

export function bankFormatter(value: number): string {
    const roundedValue = Math.round(value);
    let label = '';
    if (roundedValue > 0) {
        label = ' R';
    }
    if (roundedValue < 0) {
        label = ' L';
    }
    return Math.abs(roundedValue).toString().concat(label);
}

export function gLoadFormatter(value: number): string {
    const roundedValue = value.toFixed(2);
    return roundedValue.toString().concat(' g');
}
